/* eslint-disable */
export default class PoseDrawer {
  static drawResults (results, canvas, opts = {}) {
    const canvasCtx = canvas.getContext('2d', { willReadFrequently: true })
    canvasCtx.save()
    canvasCtx.clearRect(0, 0, canvas.width, canvas.height)
    const color = opts.color ?? '#FFFFFF'
    const rightArmColor = opts.rightArmColor;
    const leftArmColor = opts.leftArmColor;
    const leftLegColor = opts.leftLegColor;
    const rightLegColor = opts.rightLegColor;
    PoseDrawer.drawConnectors(canvasCtx, results.poseLandmarks, {
      color,
      lineWidth: 3,
      leftArmColor,
      rightArmColor,
      leftLegColor,
      rightLegColor,
    })
    PoseDrawer.drawLandmarks(canvasCtx, results.poseLandmarks, {
      color,
      radius: 5,
      lineWidth: 3,
      leftArmColor,
      rightArmColor,
      leftLegColor,
      rightLegColor,
    })
  }

  static drawLandmarks (ctx, landmarks, opts = {}) {
    if (!Array.isArray(landmarks)) { return }

    const { width } = ctx.canvas
    const { height } = ctx.canvas
    const radius = opts.radius ? opts.radius : 6
    ctx.save()
    for (const i of [11, 12, 13, 14, 15, 16, 23, 24, 25, 26, 27, 28]) {
      const point = landmarks[i]
      ctx.beginPath()
      ctx.arc(point.x * width, point.y * height, radius, 0, 2 * Math.PI, false)
      ctx.lineWidth = opts.lineWidth ? opts.lineWidth : 2
      ctx.fillStyle = opts.color ? opts.color : '#FFFFFF'

      if (opts.leftArmColor && (i === 11 || i === 13 || i === 15)) {
        ctx.fillStyle = opts.leftArmColor
      }
      if (opts.rightArmColor && (i === 12 || i === 14 || i === 16)) {
        ctx.fillStyle = opts.rightArmColor
      }
      if (opts.leftLegColor && (i === 23 || i === 25 || i === 27)) {
        ctx.fillStyle = opts.leftLegColor
      }
      if (opts.rightLegColor && (i === 24 || i === 26 || i === 28)) {
        ctx.fillStyle = opts.rightLegColor
      }

      ctx.fill()
      ctx.restore()
    }
  }

  static drawConnectors (ctx, landmarks, opts = {}) {
    if (!Array.isArray(landmarks)) { return }
    const { width } = ctx.canvas
    const { height } = ctx.canvas
    ctx.save()
    for (const connect of [
      [11, 12], [11, 23], [12, 24], [23, 24], // trunk
      [11, 13], [13, 15], // left arm
      [12, 14], [14, 16], // right arm
      [23, 25], [25, 27], // left leg
      [24, 26], [26, 28], // right leg
    ]) {
      const p1 = landmarks[connect[0]]
      const p2 = landmarks[connect[1]]
      ctx.beginPath()
      ctx.lineWidth = opts.lineWidth ? opts.lineWidth : 4
      ctx.strokeStyle = opts.color ? opts.color : '#FFFFFF'

      if (opts.leftArmColor && connect.includes(13)) {
        ctx.strokeStyle = opts.leftArmColor
      }
      if (opts.rightArmColor && connect.includes(14)) {
        ctx.strokeStyle = opts.rightArmColor
      }
      if (opts.leftLegColor && connect.includes(25)) {
        ctx.strokeStyle = opts.leftLegColor
      }
      if (opts.rightLegColor && connect.includes(26)) {
        ctx.strokeStyle = opts.rightLegColor
      }

      ctx.moveTo(p1.x * width, p1.y * height)
      ctx.lineTo(p2.x * width, p2.y * height)
      ctx.stroke()
      ctx.restore()
    }
  }

  static drawHeadEmoji (ctx, landmarks, opts = {}) {
    if (!Array.isArray(landmarks)) { return }
    const { width } = ctx.canvas
    const { height } = ctx.canvas
    const emoji = opts.emoji ? opts.emoji : '😜'
    const minSize = opts.minSize ? opts.minSize : 60

    const nose = landmarks[0]
    const midShoulder = { x: (landmarks[11].x + landmarks[12].x) / 2, y: (landmarks[11].y + landmarks[12].y) / 2 }
    const dx = (midShoulder.x - nose.x) * width
    const dy = (midShoulder.y - nose.y) * height
    const headLen = Math.max(minSize, Math.floor(Math.sqrt(dx * dx + dy * dy)))
    ctx.font = `${headLen}px serif`
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.fillText(emoji, nose.x * width, nose.y * height)
  }
}
